import { environment } from '@environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export function appInsightsFactory(): ApplicationInsights {
    return new ApplicationInsights({
        config: {
            instrumentationKey: environment.INSTRUMENTATION_KEY
        }
    });
}